import { render, staticRenderFns } from "./allFileDetail.vue?vue&type=template&id=bfcbccc8&scoped=true&"
import script from "./allFileDetail.vue?vue&type=script&lang=js&"
export * from "./allFileDetail.vue?vue&type=script&lang=js&"
import style0 from "./allFileDetail.vue?vue&type=style&index=0&id=bfcbccc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcbccc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfcbccc8')) {
      api.createRecord('bfcbccc8', component.options)
    } else {
      api.reload('bfcbccc8', component.options)
    }
    module.hot.accept("./allFileDetail.vue?vue&type=template&id=bfcbccc8&scoped=true&", function () {
      api.rerender('bfcbccc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/allFileDetail.vue"
export default component.exports